module.exports = __webpack_public_path__ + "DINNextLTPro-MediumItalic.ttf?b562fc277f48dbc2c2ddd2c3b48b1208";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-MediumItalic.ttf
// module id = 1438
// module chunks = 0